export default {
	init() {
		// JavaScript to be fired on all pages
		// ----- mobile menu 
		$('.c-header__toggle').on('click', function(){
			$(this).toggleClass('active');
			$('#mobile-menu').toggleClass('active');
		});

		$('#mobile-menu').on('click', '.menu-item-has-children > a', function(e){
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).siblings('.sub-menu').slideToggle();
		});

		// ----- feature slider
		$('.c-feature-slider').slick({
			'arrows' : true,
			'autoplay' : true,
			'dots' : true,
			'fade' : true,
			'infinite' : true,
			'rows' : 0,
			'slide' : '.c-feature-slider__slide',
			'slidesToScroll' : 1,
			'slidesToShow' : 1,
			'prevArrow' : '<span class="c-feature-slider__arrow c-feature-slider__prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="37" width="21" fill="#fff"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
			'nextArrow' : '<span class="c-feature-slider__arrow c-feature-slider__next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="37" width="21" fill="#fff"><path stroke="#c89c39" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>'
		});

		// ----- sidebar slider
		$('.c-main__sidebar__featured__slider').slick({
			'arrows' : true,
			'appendArrows' : '.c-main__sidebar__featured__slider__arrows',
			'autoplay' : false,
			'dots' : false,
			'fade' : false,
			'infinite' : true,
			'rows' : 0,
			'slide' : '.c-main__sidebar__featured__single',
			'slidesToScroll' : 1,
			'slidesToShow' : 1,
			'prevArrow' : '<span class="c-main__sidebar__featured__slider__arrows__arrow c-main__sidebar__featured__slider__arrows__prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="14" height="25" fill="#916f23"><path stroke="#916f23" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
			'nextArrow' : '<span class="c-main__sidebar__featured__slider__arrows__arrow c-main__sidebar__featured__slider__arrows__next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="14" height="25" fill="#916f23"><path stroke="#916f23" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>'
		});
		
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};
